import Vue from 'vue'

const MXEventBus = new Vue({})

export default MXEventBus
